/**
 * Mega menu — Featured Products panel switching + 2nd-level link sibling-dimming highlight.
 *
 * Keeps the state matching the last-hovered/focused 2nd-level submenu link active:
 *  - the Featured Products panel with a matching `data-mega-menu-panel` is shown (if any — see
 *    snippets/mega-menu-list.liquid for how panels are only rendered for collection-type links),
 *  - the active link itself gets `.mega-menu__link--active` (full opacity), and every OTHER
 *    2nd-level link in the same grid gets `.mega-menu__link--dimmed` (reduced opacity), matching
 *    the main header nav's hover-dimming behavior. Both classes are applied directly by JS rather
 *    than inferred by CSS, so there's no ambiguity about which link is excluded from dimming.
 *
 * Why JS instead of pure CSS :hover: both behaviors need to survive the pointer traveling off the
 * link — across the gap, into the Featured Products panel — and must only change when a
 * *different* 2nd-level link is hovered, or when the pointer/focus leaves the mega menu entirely.
 * That's state that has to persist while the pointer is over neutral space (the column gap, etc.),
 * which plain :hover/:has() can't express reliably.
 *
 * Implemented with delegated listeners on `document`, bound once, so this keeps working
 * regardless of when/how many times the mega menu markup is (re)rendered by section hydration.
 */
(function () {
  if (window.__megaMenuFeaturedProductsBound) return;
  window.__megaMenuFeaturedProductsBound = true;

  var PANEL_ACTIVE_CLASS = 'mega-menu__content-list--active';
  var LINK_ACTIVE_CLASS = 'mega-menu__link--active';
  var LINK_DIMMED_CLASS = 'mega-menu__link--dimmed';

  function setActiveMegaMenuItem(grid, itemId) {
    var panels = grid.querySelectorAll('[data-mega-menu-panel]');
    for (var i = 0; i < panels.length; i++) {
      var panelMatches = panels[i].getAttribute('data-mega-menu-panel') === itemId;
      panels[i].classList.toggle(PANEL_ACTIVE_CLASS, panelMatches);
    }

    var links = grid.querySelectorAll('[data-mega-menu-link]');
    for (var j = 0; j < links.length; j++) {
      var linkMatches = links[j].getAttribute('data-mega-menu-link') === itemId;
      // The active link: full opacity, never dimmed. Every other link: dimmed, never "active".
      links[j].classList.toggle(LINK_ACTIVE_CLASS, linkMatches);
      links[j].classList.toggle(LINK_DIMMED_CLASS, !linkMatches);
    }
  }

  function clearActiveMegaMenuItem(grid) {
    var activePanels = grid.querySelectorAll('[data-mega-menu-panel].' + PANEL_ACTIVE_CLASS);
    for (var i = 0; i < activePanels.length; i++) {
      activePanels[i].classList.remove(PANEL_ACTIVE_CLASS);
    }

    var links = grid.querySelectorAll(
      '[data-mega-menu-link].' + LINK_ACTIVE_CLASS + ', [data-mega-menu-link].' + LINK_DIMMED_CLASS
    );
    for (var j = 0; j < links.length; j++) {
      links[j].classList.remove(LINK_ACTIVE_CLASS, LINK_DIMMED_CLASS);
    }
  }

  // Activate the matching panel + link highlight when a tagged submenu link is hovered/focused.
  function onEnter(event) {
    var link = event.target.closest && event.target.closest('[data-mega-menu-link]');
    if (!link) return;

    var grid = link.closest('.mega-menu__grid');
    if (!grid) return;

    setActiveMegaMenuItem(grid, link.getAttribute('data-mega-menu-link'));
  }

  // Clear the active state only once the pointer/focus has actually left the whole grid
  // (not just the specific link or panel it was previously over).
  function onLeave(event) {
    var grid = event.target.closest && event.target.closest('.mega-menu__grid');
    if (!grid) return;

    var next = event.relatedTarget;
    if (next && grid.contains(next)) return;

    clearActiveMegaMenuItem(grid);
  }

  document.addEventListener('pointerover', onEnter);
  document.addEventListener('focusin', onEnter);
  document.addEventListener('pointerout', onLeave);
  document.addEventListener('focusout', onLeave);
})();
